module.exports = "<router-outlet></router-outlet>\r\n<app-modal-manager></app-modal-manager>\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main